// chakra imports
import {Box, Flex, Image, Stack} from "@chakra-ui/react";
//   Custom components
import Brand from "components/sidebar/components/Brand";
import Links from "components/sidebar/components/Links";
import React from "react";
import logo from 'assets/images/Logo.avif'

// FUNCTIONS

function SidebarContent() {
    // SIDEBAR
    return (
        <Flex direction='column' height='100%' pt='25px' px="16px" borderRadius='30px'>
            <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
                <Image
                    src={logo}
                    alt="Sample Image"
                    boxSize="125px"
                    objectFit="cover"
                    borderRadius="md"
                />
                <Brand/>
            </Box>

            <Stack direction='column' mb='auto'>
                <Box ps='20px' pe={{md: "16px", "2xl": "1px"}}>
                    <Links/>
                </Box>
            </Stack>
        </Flex>
    );
}

export default SidebarContent;
